import React from "react";
import { formatDateISO } from "../../utils/date";
import { Modal, Button } from "react-bootstrap";
import "./SpeciesModal.css";
import asaImage from "../../assets/asa.png";
import "./TermsModal";

type SpeciesModalProps = {
  show: boolean;
  onHide: () => void;
  onRequestDownload?: () => void; // novo fluxo: abrir termos antes de baixar
  speciesData: {
    id: number;
    species: string;
    code: string;
    country: string;
    region: string;
    state: string;
    city: string;
    latitude: string;
    longitude: string;
    altitude: string;
    collectionDate: string;
    collector: string;
    collectorInstitution: string;
    photoAuthor: string;
    photoAuthorInstitution: string;
    sisbio: string;
    sisgen: string;
    observations: string;
    imageUrl: string;
  };
};

const SpeciesModal = ({
  show,
  onHide,
  speciesData,
  onRequestDownload,
}: SpeciesModalProps) => {

  const handleDownload = () => {
    if (onRequestDownload) {
      onRequestDownload();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="species-modal"
      centered
      className="species-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="species-modal">Informações</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-content-grid">
          <div className="species-image">
            <img
              src={speciesData.imageUrl || asaImage}
              alt={speciesData.species || "Espécie"}
              style={{
                maxWidth: "100%",
                maxHeight: "400px",
                objectFit: "contain",
              }}
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).src = asaImage;
              }}
            />
          </div>
          <div className="info-grid">
            <div className="info-column">
              <p>
                <strong>Espécie:</strong> {speciesData.species || "-"}
              </p>
              <p>
                <strong>Código da imagem:</strong> {speciesData.code || "-"}
              </p>
              <p>
                <strong>País:</strong> {speciesData.country || "-"}
              </p>
              <p>
                <strong>Região:</strong> {speciesData.region || "-"}
              </p>
              <p>
                <strong>Estado:</strong> {speciesData.state || "-"}
              </p>
              <p>
                <strong>Município:</strong> {speciesData.city || "-"}
              </p>
              <p>
                <strong>Latitude:</strong> {speciesData.latitude || "-"}
              </p>
              <p>
                <strong>Longitude:</strong> {speciesData.longitude || "-"}
              </p>
            </div>
            <div className="info-column">
              <p>
                <strong>Altitude:</strong> {speciesData.altitude || "-"}
              </p>
              <p>
                <strong>Data de coleta:</strong>{" "}
                {speciesData.collectionDate
                  ? formatDateISO(speciesData.collectionDate)
                  : "-"}
              </p>
              <p>
                <strong>Coletor:</strong> {speciesData.collector || "-"}
              </p>
              <p>
                <strong>Instituição do Coletor:</strong>{" "}
                {speciesData.collectorInstitution || "-"}
              </p>
              <p>
                <strong>Autor da foto:</strong> {speciesData.photoAuthor || "-"}
              </p>
              <p>
                <strong>Instituição do Autor da foto:</strong>{" "}
                {speciesData.photoAuthorInstitution || "-"}
              </p>
              <p>
                <strong>SISBIO:</strong> {speciesData.sisbio || "-"}
              </p>
              <p>
                <strong>SISGEN:</strong> {speciesData.sisgen || "-"}
              </p>
              <p>
                <strong>Observações:</strong> {speciesData.observations || "-"}
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} className="exit-button">
          Sair
        </Button>
        <Button
          variant="primary"
          onClick={handleDownload}
          className="download-button"
        >
          Baixar Imagem
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SpeciesModal;
